module.exports = __webpack_public_path__ + "static/media/grade4.d7777385.jpg";